export enum Language {
  ENG = 'ENG',
  HEB = 'HEB'
}
